import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=62004eba&"
import script from "./error-404.js?vue&type=script&lang=js&"
export * from "./error-404.js?vue&type=script&lang=js&"
import style0 from "./error-404.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports